// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDT7SoXhMMwSRosXu-HRzS3z_k4_-g4sbg",
  authDomain: "caijigame-8ed8c.firebaseapp.com",
  databaseURL: "https://caijigame-8ed8c.firebaseio.com",
  projectId: "caijigame-8ed8c",
  storageBucket: "caijigame-8ed8c.appspot.com",
  messagingSenderId: "817595704179",
  appId: "1:817595704179:web:92547999f19aa000e1db06",
  measurementId: "G-BKDRE67P3E",
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

const isFacebookApp =
  navigator.userAgent.indexOf("FBAN") > -1 ||
  navigator.userAgent.indexOf("FBAV") > -1 ||
  navigator.vendor.indexOf("FBAN") > -1 ||
  navigator.vendor.indexOf("FBAV") > -1;

/**
 * firebase 统计事件
 * @param {string} eventName 事件名
 * @param {{[key: string]: any}} eventParams 事件参数
 */
function logEvent(eventName, eventParams = {}) {
  firebase.analytics().logEvent(eventName, eventParams);
}

// fb初始化，返回当前应用授权状态
/* eslint-disable */
function fbInit(appId, version) {
  return new Promise((resolve, reject) => {
    window.fbAsyncInit = function () {
      FB.init({
        appId: appId,
        cookie: true,
        xfbml: true,
        version: version,
      });
      // FB.AppEvents.logPageView();
      FB.getLoginStatus(function (response) {
        console.log("---", response);
        if (response.status === "connected") {
          resolve(response.authResponse);
        } else {
          reject(response);
        }
      }, true);
    };
    (function (d, s, id) {
      var js;
      var fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  });
}

// fb登录
function fbLogin() {
  return new Promise((resolve, reject) => {
    FB.login(
      function (response) {
        // console.log(response);
        if (response.status === "connected") {
          resolve(response.authResponse);
        } else {
          reject(response);
        }
      },
      {
        scope: "email",
        return_scopes: true,
      }
    );
  });
}

// fb登出
function fbLogout() {
  return new Promise((resolve, reject) => {
    FB.getLoginStatus(function (response) {
      if (response.status === "connected") {
        FB.logout(function (response) {
          resolve(response);
        });
      } else {
        reject(response);
      }
    });
  });
}

// fb校验登录状态
function fbAuth() {
  return new Promise((resolve, reject) => {
    FB.getLoginStatus(function (response) {
      // console.log(response);
      if (response.status === "connected") {
        resolve(response.authResponse);
      } else {
        reject(response);
      }
    }, true);
  });
}

// google初始化
const googleUser = {};
let auth2;
function googleInit(clientId) {
  (function (d, s, id) {
    var js;
    var fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = "https://apis.google.com/js/api:client.js";
    fjs.parentNode.insertBefore(js, fjs);
    js.onload = function () {
      startApp(clientId);
    };
  })(document, "script", "google-jssdk");
}

function startApp(clientId) {
  gapi.load("auth2", function () {
    // Retrieve the singleton for the GoogleAuth library and set up the client.
    auth2 = gapi.auth2.init({
      client_id: clientId,
      cookiepolicy: "single_host_origin",
      // Request scopes in addition to 'profile' and 'email'
      // scope: 'additional_scope'
    });
  });
}

// google登录
function googleLogin() {
  return new Promise((resolve, reject) => {
    auth2
      .signIn()
      .then((res) => {
        resolve(res.getAuthResponse());
      })
      .catch((err) => {
        reject(JSON.stringify(err, undefined, 2));
      });
  });
}

// fb分享
function fbShare(url) {
  return new Promise((resolve, reject) => {
    FB.ui(
      {
        method: "share",
        href: url,
      },
      function (response) {
        console.log(response);
        if (!response || response.error_message) {
          reject(response);
        }
        resolve(response);
      }
    );
  });
}

// fb分享好友
function fbShareFriend(url) {
  console.log(url);
  return new Promise((resolve, reject) => {
    FB.ui(
      {
        method: "send",
        link: url,
        display: "popup",
      },
      function (response) {
        console.log(response);
        if (!response || response.error_message) {
          reject(response);
        }
        resolve(response);
      }
    );
  });
}

// naver登录
function naverInit(clientId, callbackUrl) {
  return new Promise((resolve, reject) => {
    (function (d, s, id) {
      var js;
      var fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://static.nid.naver.com/js/naveridlogin_js_sdk_2.0.0.js";
      fjs.parentNode.insertBefore(js, fjs);
      js.onload = function () {
        var naverLogin = new naver.LoginWithNaverId({
          clientId: clientId,
          callbackUrl: callbackUrl,
          isPopup: false,
          callbackHandle: true,
          loginButton: { color: "green", type: 3, height: 60 },
        });
        naverLogin.init();
        naverLogin.getLoginStatus(function (status) {
          if (status) {
            // 已登录
            resolve(naverLogin.accessToken.accessToken);
          } else {
            // 未登录
            reject("Not Logged In");
          }
        });
      };
    })(document, "script", "naver-jssdk");
  });
}
export {
  isFacebookApp,
  firebase,
  fbInit,
  fbLogin,
  fbLogout,
  fbShare,
  fbAuth,
  googleInit,
  googleLogin,
  fbShareFriend,
  naverInit,
  logEvent,
};
